/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsStaggeredSubcategoryListViewProps } from '../../../modules/hosports-staggered-subcategory-list/./hosports-staggered-subcategory-list';
import StaggeredSubcategoryList from './../../../baseComponents/staggered-subcategory-list/./staggered-subcategory-list';

class StaggeredSubcategoryListView extends React.Component<IHosportsStaggeredSubcategoryListViewProps> {
  render() {
    let { config } = this.props;
    if(!config.subcategories) return <span />
    return (
        <StaggeredSubcategoryList
          subcategories = {config.subcategories}
          year={config.year}
          decorativeText={config.decorativeText}
        />
    );
  }
}

export default StaggeredSubcategoryListView;
